import React, { useEffect, useState } from 'react';
import CodePrintPage from '../components/inventory/CodePrintPage';
import { productsApi, storesApi } from '../services/api';

export default function PrintQrCodePage() {
    const [products, setProducts] = useState([]);
    const [stores, setStores] = useState([]);

    useEffect(() => {
        productsApi.list({ limit: 200 }).then((res) => setProducts(res?.data?.data || []));
        storesApi.list({ limit: 200 }).then((res) => setStores(res?.data?.data || []));
    }, []);

    const onGenerate = async (product) => {
        const res = await productsApi.qrCode(product.id);
        return res?.success ? res.data.qr_code : null;
    };

    return <CodePrintPage title="Print QR Code" mode="qrcode" products={products} stores={stores} onGenerate={onGenerate} />;
}
